document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', function () {
  var toggle = document.querySelector('.menu-toggle');
  var menu = document.getElementById('MainNav');
  if (!toggle || !menu) return;
  toggle.addEventListener('click', function () {
    var expanded = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', String(!expanded));
    menu.classList.toggle('is-open', !expanded);
  });

  var variant = document.querySelector('[id^="Variant-"]');
  if (variant) {
    var price = document.querySelector('[id^="ProductPrice-"]');
    var submit = document.querySelector('.product-form__submit');
    var updateVariant = function () {
      var option = variant.options[variant.selectedIndex];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (submit) {
        var available = option.dataset.available === 'true';
        submit.disabled = !available;
        submit.textContent = available ? 'Add to bag' : 'Sold out';
      }
    };
    variant.addEventListener('change', updateVariant);
  }
});
